import { render, staticRenderFns } from "./file-form.vue?vue&type=template&id=1be95550&scoped=true"
import script from "./file-form.vue?vue&type=script&lang=js"
export * from "./file-form.vue?vue&type=script&lang=js"
import style0 from "vue-slider-component/theme/default.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./file-form.vue?vue&type=style&index=1&id=1be95550&prod&lang=css"
import style2 from "./file-form.vue?vue&type=style&index=2&id=1be95550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be95550",
  null
  
)

export default component.exports